import * as React from "react";
const SvgCircle = (props) => /* @__PURE__ */ React.createElement("svg", { width: "32px", height: "32px", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 32 32", xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("circle", { style: {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 10
}, cx: 16, cy: 16, r: 11 }));
export default SvgCircle;
